import { StaticPageLayout } from '@/components/layout/StaticPageLayout';

export function TermsPage() {
 return (
  <StaticPageLayout title='Terms of Service' lastUpdated='2024-03-15'>
   <p>
    Welcome to MOCK.SYSTEM. By accessing or using our platform, you agree to
    comply with and be bound by these Terms of Service.
   </p>

   <h3>1. Acceptable Use</h3>
   <p>
    You agree to use our platform only for lawful purposes and in a way that
    does not infringe the rights of, restrict or inhibit anyone else's use and
    enjoyment of the platform.
   </p>

   <h3>2. Account Security</h3>
   <p>
    You are responsible for safeguarding the password that you use to access the
    service and for any activities or actions under your password.
   </p>

   <h3>3. Intellectual Property</h3>
   <p>
    The content, organization, graphics, design, compilation, magnetic
    translation, digital conversion and other matters related to the Site are
    protected under applicable copyrights, trademarks and other proprietary
    (including but not limited to intellectual property) rights.
   </p>

   <h3>4. Termination</h3>
   <p>
    We may terminate or suspend access to our Service immediately, without prior
    notice or liability, for any reason whatsoever, including without limitation
    if you breach the Terms.
   </p>
  </StaticPageLayout>
 );
}
